import * as yup from 'yup';

import { locales } from '@/features/validation/locales';
import { GENDER } from '@/features/Clients/genderTypes';

yup.setLocale(locales);

export const clientAddressBaseSchema = yup.object({
  strasse: yup.string().default(''),
  hausnummer: yup.string().default(''),
  plz: yup.string().default(''),
  ort: yup.string().default(''),
});

export const clientSchemaPWApi = yup.object({
  id: yup.number().required(),
  url: yup.string(),
  vorname: yup.string(),
  nachname: yup.string(),
  email: yup.string(),
  birthDate: yup.string(),
  adresse: clientAddressBaseSchema,
});

export const NO_SALUTATION_SELECTED = 4;

export const clientSchema = yup.object({
  id: yup.number().nullable().default(null),
  anredeId: yup.number().default(NO_SALUTATION_SELECTED),
  anteilTaetigkeitBuero: yup.number().default(70),
  adresse: clientAddressBaseSchema,
  bankverbindung: yup.object({
    iban: yup.string().default(''),
    bic: yup.string().default(''),
    bankname: yup.string().default(''),
  }),
  familienstand: yup.string().default(''),
  titel: yup.string().default(''),
  vorname: yup.string().default(''),
  nachname: yup.string().default(''),
  geschlecht: yup.string().default(GENDER.MALE),
  geburtsdatum: yup.date().nullable().default(null),
  nationalitaet: yup.string().default(''),
  geburtsname: yup.string().default(''),
  geburtsort: yup.string().default(''),
  geburtsland: yup.string().default(''),
  beruf: yup.string().default(''),
  berufsgruppe: yup.string().default(''),
  nichtraucher: yup.string().default(''),
  email: yup.string().default(''),
  telefon: yup.string().default(''),
  mobil: yup.string().default(''),
  fax: yup.string().default(''),
  personalverantwortung: yup.number().default(0),
  gewicht: yup.number().nullable().default(null),
  groesse: yup.number().nullable().default(null),
  hoechsterBildungsabschluss: yup.string().default(''),
  anzahlKinder: yup.number().default(0),
  firma: yup.string().default(''),
  fuehrerscheindatum: yup.date().nullable().default(null),
  // do we need this?
  kundennummer: yup.string().default(''),
});

export const persistedClientSchema = clientSchema.concat(
  yup.object({
    id: yup.number(),
  }),
);
